import CompanyFeeds from './CompanyFeeds';

export default CompanyFeeds;
